import getRandomUid from './uid';
import createGid from './gid';
import Util from './utilPc';
const pcVideoUtil = new Util();

/* eslint-disable */
/**
 * 格式化视频防盗链相关机制
 * @param {object} videoinfo
 * @param {string} gid
 * @return {object}
 */
function formatParams(videoinfo, gid = createGid(), version) {
    let uid = '';
    const { liveVideoId, categoryId, createdate, columnName } = videoinfo;

    if (pcVideoUtil.playerGetCookie('userid') === '') {
        uid = getRandomUid();
        pcVideoUtil.playerSetCookie('userid', uid, {
            domain: '.ifeng.com',
            path: '/',
            expires: 60 * 24 * 360
        });
    } else {
        uid = pcVideoUtil.playerGetCookie('userid');
    }

    const cat = typeof categoryId !== 'undefined' ? categoryId : '';
    const dt = new Date(createdate).getTime();
    let from = 'izhibo_h5';
    const pver = version || 'vHTML5Player_v2.0.0';
    const platform = 'pc';
    const sourceType = 'h5';
    let ptype = '';

    if (cat != '') {
        ptype = cat.split('-')[0];
        // if (ptype == '154') {
        //     from = 'v_Doc';
        // } else if (ptype == '171') {
        //     from = 'v_Biz';
        // } else {
        //     from = 'v_Free';
        // }
    }

    return {
        vid: liveVideoId,
        uid,
        from,
        pver,
        se: encodeURIComponent(columnName),
        cat,
        ptype,
        platform,
        dt,
        gid,
        sourceType
    };
}

export default formatParams;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.util/app/lib/auth/utils/formatParams.js